// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var WarningSection__Jsx3 = require("../../../uikit/reason/atoms/Sections/WarningSection__Jsx3.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationPageNotAnonymousWarning_conversationContext_graphql = require("../../../__generated__/ConversationPageNotAnonymousWarning_conversationContext_graphql.bs.js");

var convertFragment = ConversationPageNotAnonymousWarning_conversationContext_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageNotAnonymousWarning_conversationContext_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageNotAnonymousWarning_conversationContext_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageNotAnonymousWarning_conversationContext_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageNotAnonymousWarning_conversationContext_graphql.node, convertFragment, fRef);
}

var ConversationContextFragment_forSalePropertyMatchingType_decode = ConversationPageNotAnonymousWarning_conversationContext_graphql.Utils.forSalePropertyMatchingType_decode;

var ConversationContextFragment_forSalePropertyMatchingType_fromString = ConversationPageNotAnonymousWarning_conversationContext_graphql.Utils.forSalePropertyMatchingType_fromString;

var ConversationContextFragment = {
  forSalePropertyMatchingType_decode: ConversationContextFragment_forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: ConversationContextFragment_forSalePropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageNotAnonymousWarning(props) {
  var __isNewConversation = props.isNewConversation;
  var isNewConversation = __isNewConversation !== undefined ? __isNewConversation : false;
  var conversationContext = use(props.conversationContext);
  var hasAnonymousMatches;
  if (conversationContext !== undefined) {
    if (conversationContext.__typename === "AvailableConversationContext") {
      var match = conversationContext.context;
      hasAnonymousMatches = match.__typename === "BuyerNeedV5" ? Core__Array.filterMap(match.currentUsersMatches.edges, (function (v) {
                if (v === undefined) {
                  return ;
                }
                var match = v.node.source;
                var match$1 = match.forSalePropertyMatchingType;
                if (match$1 !== undefined && (match$1 === "QUIET" || match$1 === "ONE_WAY" || match$1 === "BROADCAST" || match$1 === "QUIET_ANONYMOUS") && match$1 === "QUIET_ANONYMOUS") {
                  return Caml_option.some(Core__Option.map(match.client, (function (c) {
                                    return c.displayName;
                                  })));
                }
                
              })) : [];
    } else {
      hasAnonymousMatches = [];
    }
  } else {
    hasAnonymousMatches = [];
  }
  var agentDisplayName;
  if (conversationContext !== undefined && conversationContext.__typename === "AvailableConversationContext") {
    var match$1 = conversationContext.context;
    if (match$1.__typename === "BuyerNeedV5") {
      var match$2 = match$1.agent;
      agentDisplayName = match$2 !== undefined ? match$2.displayName : undefined;
    } else {
      agentDisplayName = undefined;
    }
  } else {
    agentDisplayName = undefined;
  }
  if (hasAnonymousMatches.length === 0) {
    return null;
  }
  var len = hasAnonymousMatches.length;
  var tmp;
  if (len !== 1) {
    tmp = len !== 0 ? "Your name remains hidden on " + hasAnonymousMatches.length.toString() + " of your matching sellers" : "";
  } else {
    var singleClientName = hasAnonymousMatches[0];
    var clientName = Core__Option.getOr(singleClientName, "name unavailable");
    tmp = "Your name remains hidden on your seller \"" + clientName + "\"";
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs(WarningSection__Jsx3.make, {
                    children: [
                      isNewConversation ? JsxRuntime.jsx("div", {
                              children: "This conversation will not be anonymous",
                              className: "mb-2 font-bold"
                            }) : null,
                      tmp + ". However, " + (
                        agentDisplayName !== undefined ? agentDisplayName + " will see your name" : "your name will be visible"
                      ) + " in this conversation"
                    ]
                  }),
              className: "mt-2"
            });
}

var make = ConversationPageNotAnonymousWarning;

exports.ConversationContextFragment = ConversationContextFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
